import { ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs.page';
import { AuthGuard } from '@1bill-app/services/auth/auth.guard';

// Children of main routing => /app
const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('../tab-home/tab-home.module').then((m) => m.TabHomePageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'offers',
        loadChildren: () => import('../offers/offers.module').then((m) => m.OffersPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'offer/:catId/:offerId',
        loadChildren: () => import('../offer/offer.module').then((m) => m.OfferPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'help',
        loadChildren: () => import('../../pages/help/help.module').then((m) => m.HelpPageModule),
     
      },
      {
        path: 'history',
        loadChildren: () =>
          import('../history-list/history-list.module').then((m) => m.HistoryListPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'bills',
        loadChildren: () => import('../bills/bills.module').then((m) => m.BillsPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'funding',
        loadChildren: () =>
          import('../funding/funding.module').then((m) => m.FundingPageModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('../notifications/notifications.module').then(
            (m) => m.NotificationsPageModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: '',
        redirectTo: ROUTE_HOMEPAGE,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: ROUTE_HOMEPAGE,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule {}
